import { render, staticRenderFns } from "./dashboard-no-data.vue?vue&type=template&id=5c1975cd&scoped=true&"
import script from "./dashboard-no-data.vue?vue&type=script&lang=js&"
export * from "./dashboard-no-data.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-no-data.vue?vue&type=style&index=0&id=5c1975cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1975cd",
  null
  
)

export default component.exports